import { PropsWithChildren } from 'react';
import { DurationVitalGate, DurationVitalProvider, ReportDurationVital } from './durationVital';

export const SECOND_LOOK_PREQUAL_TO_OFFERS_VITAL = 'second_look.prequal_to_offers';

/** Which state the offers screen settled on, so slow successes stay separable from timeouts. */
export type SecondLookOffersOutcome = 'offers' | 'no_offers';

interface SecondLookPrequalToOffersProviderProps extends PropsWithChildren {
    context?: Record<string, unknown>;
}

/**
 * Place where the second-look prequalification result is first rendered. The clock starts when we
 * learn the applicant is prequalified, which trails the lender's own decision by up to one poll.
 */
export const SecondLookPrequalToOffersProvider = ({
    context,
    children,
}: SecondLookPrequalToOffersProviderProps) => (
    <DurationVitalProvider vitalName={SECOND_LOOK_PREQUAL_TO_OFFERS_VITAL} context={context}>
        {children}
    </DurationVitalProvider>
);

interface ReportSecondLookPrequalToOffersProps {
    outcome: SecondLookOffersOutcome;
}

/**
 * Reports without wrapping any UI. Use where the screen renders before its outcome is final, so
 * reporting has to wait for the data behind it to settle.
 */
export const ReportSecondLookPrequalToOffers = ({
    outcome,
}: ReportSecondLookPrequalToOffersProps) => <ReportDurationVital context={{ outcome }} />;

interface SecondLookPrequalToOffersGateProps extends PropsWithChildren {
    outcome: SecondLookOffersOutcome;
}

/** Place around the settled offers UI so the vital excludes the offer-polling loader. */
export const SecondLookPrequalToOffersGate = ({
    outcome,
    children,
}: SecondLookPrequalToOffersGateProps) => (
    <DurationVitalGate context={{ outcome }}>{children}</DurationVitalGate>
);
